<template>
    <span class="sub-title">
        <slot />
    </span>
</template>

<script>
export default {
    name: "SubTitle"
}
</script>

<style scoped>
    .sub-title {
        color: #808891;
    }
</style>